document.addEventListener('DOMContentLoaded', function() {
  const typeButtons = document.querySelectorAll('.ingredient-text');
  const ingredientsList = document.querySelector('.ingredients-list');
  
  if (!ingredientsList || typeButtons.length === 0) return;

  // Mobile accordion: letter headers toggle ingredient-letter-items (all open by default)
  const letterHeaders = ingredientsList.querySelectorAll('.ingredient-letter-header');
  letterHeaders.forEach(header => {
    header.addEventListener('click', function() {
      if (window.matchMedia('(min-width: 768px)').matches) return;
      const group = this.closest('.ingredient-letter-group');
      if (!group) return;
      const isOpen = group.classList.toggle('ingredient-accordion-open');
      this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
  
  // Load ingredient types and benefits from JSON
  let ingredientsTypesData = {};
  let ingredientsBenefitsData = {};
  const typesDataScript = document.getElementById('ingredients-types-data');
  if (typesDataScript) {
    try {
      const data = JSON.parse(typesDataScript.textContent);
      if (data.ingredients) {
        data.ingredients.forEach(ing => {
          // Parse typesString into array
          if (ing.typesString && ing.typesString.trim() !== '') {
            ingredientsTypesData[ing.name] = ing.typesString.split(',').map(t => t.trim()).filter(t => t.length > 0);
          } else {
            ingredientsTypesData[ing.name] = [];
          }
          // Store benefits for popup (ing.benefits from Liquid JSON)
          ingredientsBenefitsData[ing.name] = Array.isArray(ing.benefits) ? ing.benefits : [];
        });
        // console.log('Loaded ingredient types data for', Object.keys(ingredientsTypesData).length, 'ingredients');
        // Debug: first ingredient's benefits (check if Liquid is outputting them)
        const first = data.ingredients[0];
        if (first) {
          // console.log('Ingredients benefits debug – first ingredient:', first.name, '| benefits key exists:', 'benefits' in first, '| benefits length:', first.benefits ? first.benefits.length : 0, '| sample:', first.benefits ? first.benefits.slice(0, 1) : null);
        }
      }
    } catch (e) {
      console.error('Error parsing ingredients types data:', e);
    }
  }
  
  // Update data-types attributes - check both JSON data and existing data-types attribute
  const allItems = ingredientsList.querySelectorAll('.ingredient-item');
  let itemsUpdated = 0;
  allItems.forEach(item => {
    const itemName = item.dataset.name || item.textContent.trim();
    let typesString = item.getAttribute('data-types') || item.dataset.types || '';
    
    // If data-types is empty, try to get from JSON
    if (!typesString || typesString.trim() === '') {
      if (ingredientsTypesData[itemName] && ingredientsTypesData[itemName].length > 0) {
        typesString = ingredientsTypesData[itemName].join(',');
        item.setAttribute('data-types', typesString);
        item.dataset.types = typesString;
        itemsUpdated++;
      } else {
        console.warn(`No types data found for: "${itemName}"`);
      }
    } else {
      // Types already in attribute, just log it
      itemsUpdated++;
    }
  });
  // console.log(`Processed ${itemsUpdated} items with types data out of ${allItems.length} total`);
  
  // Show sample of items with their types
  const sampleItems = Array.from(allItems).slice(0, 5).map(item => ({
    name: item.dataset.name || item.textContent.trim(),
    types: item.getAttribute('data-types') || 'none'
  }));
  // console.log('Sample items with types:', sampleItems);
  
  // Get initial active type and normalize it
  const initialTypeRaw = ingredientsList.dataset.activeType;
  const initialType = initialTypeRaw ? initialTypeRaw.toLowerCase().trim() : null;
  
  // Make sure all items are visible initially
  allItems.forEach(item => {
    item.style.display = '';
    item.removeAttribute('hidden');
  });
  
  // Filter on page load
  if (initialType) {
    // Small delay to ensure DOM is fully ready
    setTimeout(() => {
      filterIngredientsByType(initialType);
    }, 100);
  } else {
    // If no initial type, show all items
    // console.log('No initial type set, showing all items');
  }
  
  typeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Remove active class from all buttons
      typeButtons.forEach(btn => btn.classList.remove('active'));
      // Add active class to clicked button
      this.classList.add('active');
      
      // Get filter type and normalize it (lowercase, trimmed)
      const filterType = (this.dataset.filterType || this.textContent.trim()).toLowerCase().trim();
      // console.log('Button clicked, filter type:', filterType);
      ingredientsList.dataset.activeType = filterType;
      
      // Filter ingredients by type
      filterIngredientsByType(filterType);
    });
  });

  // Helper: get benefits for an ingredient by name (exact then case-insensitive match)
  function getBenefitsForIngredient(name) {
    if (!name) return [];
    const exact = ingredientsBenefitsData[name];
    if (exact && Array.isArray(exact)) return exact;
    const nameLower = name.toLowerCase().trim();
    const key = Object.keys(ingredientsBenefitsData).find(k => k && k.toLowerCase().trim() === nameLower);
    return key ? (ingredientsBenefitsData[key] || []) : [];
  }

  // Ingredient item click: open benefits popup
  const allIngredientItems = ingredientsList.querySelectorAll('.ingredient-item');
  allIngredientItems.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      const name = (this.dataset.name || this.textContent.trim()).trim();
      if (!name) return;
      const benefits = getBenefitsForIngredient(name);
      // console.log('Ingredient popup – name:', name, '| benefits count:', benefits ? benefits.length : 0);
      if (typeof window.openIngredientBenefitsPopup === 'function') {
        window.openIngredientBenefitsPopup(name, benefits);
      }
    });
  });
  
  function filterIngredientsByType(type) {
    if (!type) {
      console.warn('No type provided for filtering');
      return;
    }
    
    // console.log('Filtering by type:', type);
    
    const allItems = ingredientsList.querySelectorAll('.ingredient-item');
    const letterGroups = ingredientsList.querySelectorAll('.ingredient-letter-group');
    
    let visibleCount = 0;
    // Normalize filter type: lowercase and trim
    const filterTypeNormalized = String(type).trim().toLowerCase();
    
    // Show/hide items based on type match
    allItems.forEach((item, index) => {
      const itemName = item.dataset.name || item.textContent.trim();
      let typesArray = [];
      let shouldShow = false;
      
      // Get types from data-types (Liquid outputs comma-separated e.g. "smoothies,fruit snacks,oats")
      let itemTypes = item.getAttribute('data-types') || item.dataset.types || '';
      if (typeof itemTypes !== 'string') itemTypes = '';
      itemTypes = itemTypes.trim();
      if (itemTypes !== '') {
        // If it looks like JSON array (e.g. malformed or old format), parse it
        const first = itemTypes.charAt(0);
        if (first === '[') {
          try {
            const parsed = JSON.parse(itemTypes);
            if (Array.isArray(parsed)) {
              typesArray = parsed.map(t => String(t).trim().toLowerCase()).filter(t => t.length > 0);
            }
          } catch (_) {
            typesArray = itemTypes.replace(/[\[\]"]/g, '').split(',').map(t => t.trim().toLowerCase()).filter(t => t.length > 0);
          }
        } else {
          typesArray = itemTypes.split(',').map(t => t.trim().toLowerCase()).filter(t => t.length > 0);
        }
      }
      
      // If no types from attribute, try JSON data
      if (typesArray.length === 0) {
        if (ingredientsTypesData[itemName] && ingredientsTypesData[itemName].length > 0) {
          typesArray = ingredientsTypesData[itemName].map(t => String(t).trim().toLowerCase());
          // Update data-types attribute for future use
          item.setAttribute('data-types', typesArray.join(','));
        }
      }
      
      // Check if any type matches (case-insensitive)
      if (typesArray.length > 0) {
        shouldShow = typesArray.some(t => {
          const normalized = String(t).trim().toLowerCase();
          return normalized === filterTypeNormalized;
        });
        
      } else {
        // If no types found, show the item for every filter so the list is never empty
        shouldShow = true;
        if (index < 3) {
          console.warn(`No types for ingredient "${itemName}" – showing for all filters`);
        }
      }
      
      if (shouldShow) {
        item.style.display = '';
        item.removeAttribute('hidden');
        visibleCount++;
      } else {
        item.style.display = 'none';
        item.setAttribute('hidden', '');
      }
    });
    
    // console.log(`Filtering by "${type}": ${visibleCount} items visible out of ${allItems.length} total`);
    
    // Show/hide letter groups based on visible items
    letterGroups.forEach(group => {
      // Check for items that are visible (display is not 'none')
      const itemsInGroup = group.querySelectorAll('.ingredient-item');
      let hasVisible = false;
      
      itemsInGroup.forEach(item => {
        const computedStyle = window.getComputedStyle(item);
        if (computedStyle.display !== 'none') {
          hasVisible = true;
        }
      });
      
      if (hasVisible) {
        group.style.display = '';
        group.removeAttribute('hidden');
      } else {
        group.style.display = 'none';
        group.setAttribute('hidden', '');
      }
    });
  }
});
